import { programConfig } from '@/config';
import useGlobalConfig from '@/store/global';

import AlygloSupport from './alyglo';
import CoagadexSupport from './coagadex';
import CopaySupport from './copaySupport';
import GammakedSupport from './gammaked';
import GammaplexSupport from './gammaplex';
import GamunexSupport from './gamunex';
import KoateSupport from './koate';
import RyplazimSupport from './ryplazim';

const SUPPORT_COMPONENTS = {
  alyglo: AlygloSupport,
  coagadex: CoagadexSupport,
  gammaked: GammakedSupport,
  gammaplex: GammaplexSupport,
  gamunex: GamunexSupport,
  koate: KoateSupport,
  ryplazim: RyplazimSupport,
  wilate: CopaySupport,
  panzyga: CopaySupport,
  fibryga: CopaySupport,
  cutaquig: CopaySupport,
  octagam: CopaySupport,
  nuwiq: CopaySupport,
};

const PatientSupport = () => {
  const { program, themeColor } = useGlobalConfig();
  const name = program.name;
  const programInfo = programConfig.find((item) => item.Program === program.name);
  const SupportComponent = SUPPORT_COMPONENTS[name as keyof typeof SUPPORT_COMPONENTS];
  const supportPhone = programInfo?.SupportTeamPhone;

  if (!SupportComponent) {
    return null;
  }

  return <SupportComponent name={name} themeColor={themeColor} supportPhone={supportPhone || ''} />;
};

export default PatientSupport;
